// Köpknappen när vald variant (höjd/storlek) inte går att köpa, t.ex. slut i lager.
//
// WC markerar en sådan variant enbart med klasserna .disabled.wc-variation-is-unavailable.
// Knappen tar då fortfarande emot klick: WC öppnar en window.alert ("Den här
// produkten är inte tillgänglig …") och mini-cart.js skickar dessutom köpet,
// som servern avvisar med "Du kan inte lägga till … eftersom produkten är slut
// i lager" under mängdrabatten.
//
// Här sätts i stället disabled-propertyn — en disabled knapp tar inte emot klick,
// så varken alerten eller köpet körs — och texten byts till "Tillfälligt slut i
// lager" när varianten är slut.
//
// jQuery krävs: WC triggar show_variation/hide_variation/reset_data via jQuery.
jQuery(function ($) {
    function setButtonState($form, purchasable, inStock) {
        var $button = $form.find('.single_add_to_cart_button')
        if (!$button.length) return

        $button.prop('disabled', !purchasable)
        $button.toggleClass('lw-out-of-stock', !inStock)
        $button.text(inStock ? liGlobal.addToCartText : liGlobal.outOfStockText)
    }

    $(document.body).on('show_variation', 'form.variations_form', function (e, variation, purchasable) {
        setButtonState($(this), purchasable, !!variation.is_in_stock)
    })

    // Ingen variant vald: tillbaka till WC:s vanliga "välj alternativ"-läge.
    $(document.body).on('hide_variation reset_data', 'form.variations_form', function () {
        setButtonState($(this), true, true)
    })
})
